import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "hub-edit-wrapper" };
const _hoisted_3 = {
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
import { computed, reactive, ref, onBeforeMount, onBeforeUnmount, } from 'vue';
import { routeName } from '@/constants/routeName';
import { createHubManagementFormData as createFormData } from '@/form/form-data';
import { errorCode } from '@/error';
import HubEditBasicInfo from '@/views/HubManagement/HubEdit/BasicInfo.vue';
import HubEditWorkerOperationInfo from '@/views/HubManagement/HubEdit/WorkerOperationSetting.vue';
import HubEditAdjustmentOperationInfo from '@/views/HubManagement/HubEdit/AdjustmentOperationSetting.vue';
import { makeComponentInfoList } from '@/utils';
import { setFormData, makeWorkingTimeStringToObject, } from '@/utils/vueUtils';
import { createHubFormRules, isValidKilometerProductRange, } from '@/form/form-rules/hubManangement';
import { i18n } from '@/locales';
import CardSection from '@/components/Common/CardSection.vue';
import { useRouter, useRoute, } from 'vue-router';
import { getGlobalStore } from '@/lib/global-store';
import hubDetailPageTypeOption from '@/constants/hubManagement/hubDetailPageTypeOption';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
const lc = 'views.hub_management.';
const formRulesLc = 'form_rules.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const getComp = (n) => ({
            HubEditBasicInfo,
            HubEditWorkerOperationInfo,
            HubEditAdjustmentOperationInfo,
        }[n]);
        const route = useRoute();
        const router = useRouter();
        const vuexStore = getGlobalStore();
        const hubEditCardComponents = {
            'basic-info': makeComponentInfoList('HubEditBasicInfo', i18n.t(`${lc}basic_info`)),
            'worker-operation-setting': makeComponentInfoList('HubEditWorkerOperationInfo', i18n.t(`${lc}worker_operation_setting`)),
            'adjustment-operation-setting': makeComponentInfoList('HubEditAdjustmentOperationInfo', i18n.t(`${lc}adjustment_operation_setting`)),
        };
        const formRules = createHubFormRules(formRulesLc);
        const formRef = ref(null);
        const getHubInfo = (payload) => vuexStore.dispatch('hubManagement/hubEdit/getHubInfo', payload);
        const editHubInfo = (payload) => vuexStore.dispatch('hubManagement/hubEdit/editHubInfo', payload);
        const resetHubInfo = () => vuexStore.dispatch('hubManagement/hubEdit/resetHubInfo');
        const setPageTitle = (payload) => vuexStore.dispatch('app/setPageTitle', payload);
        const getterHubInfo = computed(() => vuexStore.getters['hubManagement/hubEdit/getterHubInfo']);
        const createdFormData = createFormData();
        const createdOriginFormData = createFormData();
        const formData = reactive(createdFormData);
        const originFormData = reactive(createdOriginFormData);
        const createErrorMessageData = () => ({
            hubRepresentativePhoneExistence: '',
        });
        const initErrorMessageData = createErrorMessageData();
        const errorMessageData = reactive(initErrorMessageData);
        const initFormData = (isInitOriginFormData = false) => {
            const data = isInitOriginFormData ? originFormData : formData;
            Object.entries(getterHubInfo.value).reduce((acc, [key, value,]) => {
                if (!value) {
                    return acc;
                }
                const replacedKey = key.replace('_', '');
                const regex = new RegExp('^address|workingTime|hubConfigurationDTO|laterUseYn');
                if (regex.test(replacedKey)) {
                    return acc;
                }
                acc[replacedKey] = value;
                return acc;
            }, data);
            const { _laterUseYn, _workingTime, _hubConfigurationDTO, convertedAddressInfoToData, } = getterHubInfo.value;
            Object.keys(data.hubConfiguration).forEach((key) => {
                const originValue = _hubConfigurationDTO[key];
                const regex = new RegExp('^hubId|payCardOverYn|option');
                if (regex.test(key)) {
                    return;
                }
                // minimumKilometerProduct의 경우 originValue=0일 수 있다
                if (typeof originValue !== 'number' && !originValue) {
                    return;
                }
                const convertedStringToBoolean = originValue === 'N' || originValue === 'Y'
                    ? originValue === 'Y'
                    : originValue;
                setFormData(data, `hubConfiguration.${key}`, convertedStringToBoolean);
            });
            Object.keys(data.hubConfiguration.option).forEach((key) => {
                // 조회에서는 option에 s가 붙고 등록/수정에서는 option에 s가 붙지 않는다. 오타 주의 필요.
                const originValue = _hubConfigurationDTO.options[key];
                setFormData(data, `hubConfiguration.option.${key}`, originValue);
            });
            const convertedWorkingTime = makeWorkingTimeStringToObject(_workingTime);
            setFormData(data, 'workingTime', convertedWorkingTime);
            setFormData(data, 'laterUseYn', _laterUseYn === 'Y');
            setFormData(data, 'addressFormData', convertedAddressInfoToData);
        };
        const initPage = async () => {
            // hubDetailContent handleClickEditBtn에서 넘긴 type
            const { hubId } = route.params;
            await getHubInfo(hubId);
            setPageTitle();
        };
        const hubEditCardComponentName = computed({
            get() {
                const { pageType } = route.params;
                return hubEditCardComponents[pageType].componentName;
            },
            set() { },
        });
        const hubEditCardComponentTitle = computed({
            get() {
                const { pageType } = route.params;
                return hubEditCardComponents[pageType].title;
            },
            set() { },
        });
        const goToDetailPage = () => {
            router.push({
                name: routeName.HUB_MANAGEMENT_DETAIL,
                query: route.query,
            });
        };
        const showSuccess = (payload) => vuexStore.dispatch(snackbarActionType.showSuccess, payload);
        const showError = (payload) => vuexStore.dispatch(snackbarActionType.showError, payload);
        const isFormValid = (errorMessages) => {
            const messageList = [
                i18n.t('common.form_validation_error'),
            ];
            const isValidData = formRef.value?.validate() && !!formData.addressFormData._siDo;
            // hubRepresentativePhone 중복체크 로직이 있는 basic page에서만 체크 필요
            const isErrorMessageExist = Object.values(errorMessages)
                .some((message) => !!message);
            // kilometerProduct/minimumKilometerProduct가 있는 worker-operation page에서만 체크 필요
            const isValidKilometerRange = isValidKilometerProductRange(formData.hubConfiguration.minimumKilometerProduct, formData.hubConfiguration.kilometerProduct);
            if (isValidData && !isErrorMessageExist && isValidKilometerRange) {
                return true;
            }
            if (!isValidKilometerRange) {
                const notValidRangeErrorMessage = i18n.t('form_rules.end_value_greater_than_start', {
                    endField: i18n.t(`${lc}hub_configuration.kilometer_product`),
                    startField: i18n.t(`${lc}hub_configuration.minimum_kilometer_product`),
                });
                messageList.unshift(notValidRangeErrorMessage);
            }
            showError({
                message: messageList,
            });
            return false;
        };
        const _resetValidation = () => formRef.value?.resetValidation();
        const _onSubmit = async (submitData) => {
            try {
                const { hubId, pageType } = route.params;
                const response = await editHubInfo({
                    hubId,
                    type: pageType,
                    submitData,
                });
                if (!response.isSuccess) {
                    if (response?.reason || response.message) {
                        return showError({
                            message: errorCode[response?.reason] || response.message,
                        });
                    }
                    return showError({
                        message: i18n.t('common.unknown_error'),
                    });
                }
                goToDetailPage();
                return showSuccess({
                    message: i18n.t('views.snackbar.hub_modify_complete'),
                });
            }
            catch (error) {
                return console.log('[hubEdit onSubmit error]', error);
            }
        };
        const handleSubmitForm = () => {
            const isValid = isFormValid(errorMessageData);
            if (!isValid) {
                return;
            }
            _onSubmit(formData);
        };
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const handleClickCancelForm = async () => {
            const isInitOriginFormData = true;
            initFormData(isInitOriginFormData);
            const isSameData = objDeepCompare(originFormData, formData);
            if (isSameData) {
                goToDetailPage();
                return;
            }
            const { pageType } = route.params;
            const headerTitlePath = hubDetailPageTypeOption.find(({ type }) => type === pageType)?.title;
            const isConfirmOk = await confirm({
                headerTitle: i18n.t(headerTitlePath),
                bodyContent: i18n.t('common.confirm_before_cancel'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (isConfirmOk) {
                goToDetailPage();
            }
        };
        onBeforeMount(() => {
            resetHubInfo();
            initPage();
        });
        onBeforeUnmount(() => {
            _resetValidation();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_form, {
                        ref_key: "formRef",
                        ref: formRef,
                        onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                    }, {
                        default: _withCtx(() => [
                            _createVNode(CardSection, { title: hubEditCardComponentTitle.value }, {
                                default: _withCtx(() => [
                                    (getterHubInfo.value)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(hubEditCardComponentName.value)), {
                                            key: 0,
                                            lc: lc,
                                            "form-rules-lc": formRulesLc,
                                            "form-data": formData,
                                            "form-rules": _unref(formRules),
                                            "error-message-data": errorMessageData,
                                            onInitFormData: initFormData
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, ["form-data", "form-rules", "error-message-data"]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["title"]),
                            _createElementVNode("div", _hoisted_3, [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    class: "mr-2",
                                    onClick: handleClickCancelForm
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "width-xs": true,
                                            "size-l": true
                                        }
                                    ]
                                ]),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.save')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "width-xs": true,
                                            "size-l": true
                                        }
                                    ]
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */)
                ])
            ]));
        };
    }
});
